import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { suspense } from './utils';
const ShowTask = lazy(() => import('app/features/tasks/ShowTask'));
const TaskDetails = lazy(
  () => import('app/features/tasks/ShowTask/TaskDetails'),
);
const TaskDocuments = lazy(
  () => import('app/features/tasks/ShowTask/TaskDocuments'),
);
const TaskNotes = lazy(() => import('app/features/tasks/ShowTask/TaskNotes'));
const TasksList = lazy(() => import('app/features/tasks/TasksList'));
export default function TaskRoutes() {
  return (
    <>
      <Route path="tasks">
        <Route path="" element={suspense(<TasksList />)} />
        <Route path=":taskId" element={suspense(<ShowTask />)}>
          <Route path="details" element={suspense(<TaskDetails />)} />
          <Route path="documents" element={suspense(<TaskDocuments />)} />
          <Route path="notes" element={suspense(<TaskNotes />)} />
          <Route path="" element={<Navigate replace to="details" />} />
        </Route>
      </Route>
    </>
  );
}
